export enum PaymentDetailsDataHooks {
  PAYMENT_DETAILS = 'payment-details',
  MEMBERSHIP = 'payment-membership',
  MEMBERSHIP_VALIDATION = 'payment-membership-validation',
  MEMBERSHIP_CREDIT = 'payment-membership-credit',
  CUSTOM_PRICE = 'payment-custom-price',
}
